// EMPLOYER TOP JOBS *****************************************************************
// pathname: /v1/my-jobs
// **************************************************************************************
import { fetcherSwrBase } from '@utils/data-fetching/fetcher';


// Interface
// ********************************************
export type EmployerTopJobsResponse = ApiSchema<'MyJobResult'>;


/**
 * @description Fetch the company's most recent own jobs (top N) for the home slot.
 *
 * Backed by `GET /v1/my-jobs?page=1&limit=N&sort=recent`. Uses the session cookie
 * (`credentials: 'include'`, the fetcher default) since this is an authenticated,
 * employer-only endpoint.
 *
 * @param limit - number of jobs to fetch; default 3.
 * @param locale - locale for the Accept-Language header; default 'ro'.
 */
export const fetchEmployerTopJobs = (limit = 3, locale = 'ro'): Promise<EmployerTopJobsResponse> => (
  fetcherSwrBase<EmployerTopJobsResponse>(
    `/v1/my-jobs?page=1&limit=${limit}&sort=recent`,
    locale,
    {},
  )
);
